var compare_price_map = {};

// 初始化产品展示的Swiper组件的函数
function initProductShowSwiper() {
  var productShowThumbs = new Swiper(".tb-product-show .tb-product-show-thumbs.active", {
    spaceBetween: 8,
    slidesPerView: isMobile() ? 5 : 'auto',
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
  });
  var productShow = new Swiper(".tb-product-show .tb-product-show-slide.active", {
    loop: true,
    spaceBetween: 10,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: ".tb-product-show .swiper-button-next",
      prevEl: ".tb-product-show .swiper-button-prev",
    },
    thumbs: {
      swiper: productShowThumbs,
    },
  });
  
  return { productShowThumbs, productShow };
}

// 初始化默认的产品展示Swiper
initProductShowSwiper();

if (!isMobile()) {
  $(".tb-product-show-slide.active .tb-product-show-image").imagezoomsl({
    zoomrange: [3, 3]
  });
}

// 复制折扣码
let codeCopy = document.querySelectorAll('.tb-product-coupon-copy');
let clipboard = new Clipboard(codeCopy);
clipboard.on('success', function (e) {
  let successCon = "<div class='tb-toast'>Successfully copied!  </div>"
  $('.tb-product-coupon-wrap').append(successCon);
  setTimeout(function () {
    $('.tb-toast').remove();
  }, 1000)
});


var bodyworkSlide = new Swiper(".tb-product-grid-slide", {
  pagination: {
    el: ".tb-product-grid-slide .swiper-pagination",
  },
  on: {
    init: function (swiper) {
      if (!isMobile() || $(window).width() > 768) {
        this.disable();
        return;
      }
      this.params.spaceBetween = 10;
    },
    resize: function (swiper) {
      if (isMobile() || $(window).width() <= 768) {
        this.update();
        this.enable();
        this.params.spaceBetween = 10;
      } else {
        this.disable();
      }
    },
  },
});

var evenWorkSlide = new Swiper(".tb-product-even-slide", {
  pagination: {
    el: ".tb-product-even-slide .swiper-pagination",
  },
  lazy: {
    loadPrevNext: true,
  },
  slidesPerView : 1.2,
  on: {
    init: function (swiper) {
      if (!isMobile() || $(window).width() > 768) {
        this.disable();
        return;
      }
      this.params.spaceBetween = 10;
    },
    resize: function (swiper) {
      if (isMobile() || $(window).width() <= 768) {
        this.update();
        this.enable();
        this.params.spaceBetween = 10;
      } else {
        this.disable();
      }
    },
  },
});

var evenWorkSlidePad = new Swiper(".tb-product-even-slide-pad", {
  pagination: {
    el: ".tb-product-even-slide-pad .swiper-pagination",
  },
  slidesPerView : 1.2,
  on: {
    init: function (swiper) {
      if (!isMobile() || $(window).width() > 768) {
        this.disable();
        return;
      }
      this.params.spaceBetween = 10;
    },
    resize: function (swiper) {
      if (isMobile() && $(window).width() <= 768) {
        this.update();
        this.enable();
        this.params.spaceBetween = 10;
      } else {
        evenWorkSlidePad.slideTo(0, 100, false);//切换到第一个slide，速度为1秒
        this.disable();
      }
    },
  },
});

var sceneSlide = new Swiper(".tb-product-slideshow .tb-product-slideshow-swiper", {
  slidesPerView: 'auto',
  spaceBetween: 24,
  scrollbar: {
    el: ".tb-product-slideshow-swiper .swiper-scrollbar",
  },
  navigation: {
    nextEl: ".tb-product-slideshow .swiper-button-next",
    prevEl: ".tb-product-slideshow .swiper-button-prev",
  },
  on: {
    init: function () {
      if (isMobile() || $(window).width() <= 768) {
        this.params.spaceBetween = 12;
      }
    },
    resize: function (swiper) {
      if (isMobile() || $(window).width() <= 768) {
        this.params.spaceBetween = 12;
      }
    }
  }
});

var productBanner = new Swiper(".tb-product-banner .swiper", {
  pagination: {
    el: ".tb-product-banner .swiper-pagination",
  },
  navigation: {
    nextEl: ".tb-product-banner .swiper-button-next",
    prevEl: ".tb-product-banner .swiper-button-prev",
  }
});

var productBanner = new Swiper(".tb-product-cover-banner .swiper", {
  autoplay: {
    delay: 7000,
  },
  lazy: {
    loadPrevNext: true,
  },
  pagination: {
    el: ".tb-product-cover-banner .swiper-pagination",
  },
  navigation: {
    nextEl: ".tb-product-cover-banner .swiper-button-next",
    prevEl: ".tb-product-cover-banner .swiper-button-prev",
  }
});

var socialSlide = new Swiper(".tb-product-social-media-swiper", {
  spaceBetween: 30,
  slidesPerView : isMobile() ? 1 : 3,
  
	slidesPerGroup: isMobile() ? 1 : 3,
  pagination: {
    el: ".swiper-pagination",
  },
  lazy: {
    loadPrevNext: true,
  },
  on: {
    // init: function (swiper) {
    //   if (!isMobile() || $(window).width() > 768) {
    //     this.disable();
    //   }
    // },
    // resize: function (swiper) {
    //   if (isMobile() || $(window).width() <= 768) {
    //     this.update();
    //     this.enable();
    //   } else {
    //     this.disable();
    //   }
    // },
  }
});
$(window).resize(function(){
  var ww = $(window).width()
  if (ww<=768) {
    socialSlide.params.slidesPerView = 1;
    socialSlide.params.slidesPerGroup = 1;
  }
  if (ww>768) {
    socialSlide.params.slidesPerView = 3;
    socialSlide.params.slidesPerGroup = 3;
  }
  socialSlide.update()
});

$(function () {
  // 服务选项卡首次加载
  $('.tb-product-serve .tb-product-serve-item').eq(0).find('.tb-product-serve-title').addClass('active')
  $('.tb-product-serve .tb-product-serve-item').eq(0).find('.tb-product-serve-content').slideDown();
  let couponLen = $('.tb-product-coupon .tb-product-coupon-item').length;
  couponLen == 0 && $('.tb-product-coupon-btn').remove();
  // 选项切换
  $('.tb-product-variant-select-val').click(function (e) {
    $(this).parent().toggleClass('active');
    $(this).parent().next().slideToggle();
  });

  // 切换变体
  $('.tb-product-variant-select-list li').click(function () {
    $(this).addClass('selected').siblings().removeClass('selected');
    let text = $(this).find('.select-item-content').text();
    let id = $(this).data('variant-id');
    let variantavailable = $(this).data('variant-available');
    let variantTitle = $(this).data('variant-title');
    $(this).parent().prev().find('.tb-product-variant-select-val').val(text)
    // $(this).parent().slideUp();
    $(this).parent().prev().removeClass('active');
    $('#variantId').val(id)
    $(this).attr('data-variant-selected', true);
    $(this).siblings().attr('data-variant-selected', false);
    $('#finalPrice').html($(this).data('variant-price'));
    $('#underlinedPrice').html($(this).data('variant-compare-at-price'));
    $('.variant-price').html($(this).data('variant-price'));
    $('.variant-compare-at-price').html($(this).data('variant-compare-at-price'));
    if (variantavailable) {
      $('#addCart').text( $('#addCart').data('add-cart'));
      $('#addCart').removeClass('tb-product-handle-add-disabled').attr('disabled', false);
    } else {
      $('#addCart').text( $('#addCart').data('sold-out'));
      $('#addCart').addClass('tb-product-handle-add-disabled').attr('disabled', true);
    }

    $('.product-add-cart-botton').attr('data-variantId', id);

    // 预购文案
    let isEuPreOrder = $("#isEuPreOrder").val();
    
    if (isEuPreOrder == 'true') {
      $(".eu-pre-order-text-box").removeClass('hide');
      $(".add-cart-text-box").addClass('hide');
    } else {
      $(".eu-pre-order-text-box").addClass('hide');
      $(".add-cart-text-box").removeClass('hide');
    }

    // 在url后面加上变体id参数: ?variant=123456
    let variantId = id;
    let url = window.location.href;
    if (variantId) {
      if (url.indexOf('variant') > -1) {
        url = url.replace(/variant=[0-9]*/, 'variant=' + variantId);
      } else {
        url = url + '?variant=' + variantId;
      }
      window.history.replaceState({}, document.title, url);
    }

    // 切换变体头部文案
    $('#activity_description').html($(this).data('variant-activity_description'));
    $('#shipping_info').html($(this).data('variant-shipping_info'));
    $('#add_to_cart').html($(this).data('variant-add_to_cart'));

    // 切换变体详情
    $('.variant-detail-container').removeClass('tw-block tb-product-tab-main');
    $('.variant-detail-container').addClass('tw-hidden');
    $('.variant-detail-container.variant-detail-' + variantId).removeClass('tw-hidden');
    $('.variant-detail-container.variant-detail-' + variantId).addClass('tw-block tb-product-tab-main');

    // 切换package图片
    $('.tb-product-pack-item[data-variant-id!=""]').addClass('tw-hidden');
    $('.tb-product-pack-item[data-variant-id="' + id + '"]').removeClass('tw-hidden');

    // 切换变体图片
    changeVariantImage(id);
  })

  // 切换变体图片
  function changeVariantImage(variantId) {

    $('.tb-product-show-thumbs').removeClass('active');
    $('#variant-swiper-' + variantId).addClass('active');

    $('.tb-product-show-slide').removeClass('active');
    $('#variant-image-show-swiper-' + variantId).addClass('active');
    
    
    // 重新初始化Swiper实例绑定到新的active元素
    initProductShowSwiper();
    
    // 重新初始化imagezoomsl插件到新的active图片元素
    if (!isMobile()) {
      // 先销毁之前的imagezoomsl实例
      $(".tb-product-show-image").each(function() {
        if ($(this).data('imagezoomsl')) {
          $(this).data('imagezoomsl').remove();
        }
      });
      
      // 重新初始化到当前active的图片
      $(".tb-product-show-slide.active .tb-product-show-image").imagezoomsl({
        zoomrange: [3, 3]
      });
    }
    // 重新初始化详情的swiper
    initR09Swiper();
  }



  // 加减数量
  $('.tb-product-qty-min').click(function () {
    let qtyValue = parseInt($('.tb-product-qty-val').val());
    qtyValue !== 1 && qtyValue--;
    qtyValue == 1 ? $(this).addClass('disabled') : $(this).removeClass('disabled')
    $('.tb-product-qty-val').val(qtyValue)
  })

  $('.tb-product-qty-add').click(function () {
    let qtyValue = parseInt($('.tb-product-qty-val').val());
    qtyValue++;
    qtyValue == 1 ? $('.tb-product-qty-min').addClass('disabled') : $('.tb-product-qty-min').removeClass('disabled')
    $('.tb-product-qty-val').val(qtyValue)
  })
  $('.tb-product-payment-more p').click(function () {
    $(this).next().slideToggle();
  })


  $('.tb-product-serve-item .tb-product-serve-title').click(function () {
    $(this).toggleClass('active');
    $(this).parent().siblings().find('.tb-product-serve-title').removeClass('active');
    $(this).parent().siblings().find('.tb-product-serve-content').slideUp();
    $(this).next().slideToggle();
  })

  $('.tb-product-coupon-btn').click(function () {
    $('.tb-product-coupon-item:not(first-child)').toggleClass('active')
  })

  let paymentList = $('.tb-payment-list').html();
  $('.tb-product-payment-details').html(paymentList)
  if (!isMobile) {
    $('.tb-product-handle-checkout').on("mouseover mouseout", '.shopify-payment-button__more-options', function (event) {
      if (event.type == "mouseover") {
        $('.tb-product-payment-details').slideDown();
      } else if (event.type == "mouseout") {
        //鼠标离开
        $('.tb-product-payment-details').slideUp();
      }
    })
  }
  if (isMobile || $(window).width() <= 768) {
    $('.icon-notes').click(function () {
      $('.tb-product-payment-details').slideToggle();
    });
  }


  let productVideo = document.querySelector('#productVideo')
  $('.tb-product-video').hover(function () {
    $('#productVideo').attr('controls', true)
  }, function () {
    $('#productVideo').attr('controls', false)
  });

  $('.tb-product-spec-box dt').click(function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $(this).next().slideUp();
      $(this).find('.iconfont').addClass('icon-add').removeClass('icon-reduce')
    } else {
      $(this).addClass('active');
      $(this).next().slideDown();
      $(this).find('.iconfont').removeClass('icon-add').addClass('icon-reduce')
    }
  })

  $('.tb-product-data-title.down').click(function () {
    if ($(this).next().is(':hidden')) {
      $(this).next().slideDown();
      $(this).find('.iconfont').removeClass('icon-add').addClass('icon-reduce')
    } else {
      $(this).next().slideUp();
      $(this).find('.iconfont').addClass('icon-add').removeClass('icon-reduce')
    }
  })

  $('.tb-product-faq-item h4').click(function () {
    $(this).toggleClass('active')
    $(this).next().slideToggle();
  })
  // 点击楼层跳跃
  var flag = true //设置标识。防止出现跑马灯
  let hdHeight;
  if (sessionStorage.getItem('barStatus') || !$('.tb-product-tabs-list').attr('data-barstatus')) {
    hdHeight = 72;
  } else if ($('.tb-product-tabs-list').attr('data-barstatus')) {
    hdHeight = 112;
  }
  if (flag) {
    $(window).scroll(function () {
      var scrollT = $(window).scrollTop()
      var len = $(".tb-product-tab-main").length
      for (let i = 0; i < len; i++) {
        var bannerGap = $(".tb-product-tab-main")[i].offsetTop - $('.tb-product-tabs-list').height() - hdHeight;
        if (scrollT > bannerGap) {
          $(".tb-product-tabs-item").eq(i).addClass("active").siblings().removeClass("active")
        }
      }
    })
  }
  $(".tb-product-tabs-item").click(function () {
    flag = false;
    var index = $(this).index() //获取当前点击元素的索引  
    // $(".tb-product-tabs-item").removeClass('active');
    // $(this).addClass("active");
    if (index == 2) {
      $('.tb-product-pack-box').slideDown();
      $('.tb-product-pack .iconfont').addClass('icon-reduce').removeClass('icon-add')
    } else if (index == 3) {
      $('.tb-product-faq-box').slideDown()
      $('.tb-product-faq .iconfont').addClass('icon-reduce').removeClass('icon-add')
    }
    var top = $(".tb-product-tab-main").eq(index).offset().top - $('.tb-product-tabs-list').height() - hdHeight; //获取每个内容到顶部的距离 
    $("html,body").stop(true).animate({
      "scrollTop": top + 5
    }, function () {
      flag = true
    })
  })


  if(document.querySelector("#shopify-section-product-header > div.tb-product-price > s > span")){
    let tmp_compare_price = document.querySelector("#shopify-section-product-header > div.tb-product-price > s > span").textContent;
    let tmp_product_id = document.querySelector("#productPage").getAttribute('data-id');
    compare_price_map[tmp_product_id] = tmp_compare_price;
  }else{
    console.log('no product id');
  }
})



// 添加到购物车
let currentProduct = document.getElementById('productPage'); //当前产品ID
let variantId = document.getElementById('variantId'); //当前产品变体
let numInput = document.getElementById('productQty'); //购买页产品加购数量
let loading = document.getElementById('loading'); //加载
$('.tb-product-addBtn').click(function (e) {
  console.log('add to cart clicked');
  let id = variantId.value || currentProduct.getAttribute('data-id');
  let quantity = numInput.value;
  let formDate = {
    form_type: 'product',
    utf8: '✓',
    id,
    quantity
  }
  loading.classList.add('active');
  $.ajax({
    url: '/cart/add.js',
    type: 'POST',
    data: formDate,
    dataType: 'json',
    success(res) {
      if (res) {
        getCartData();
        $('.tb-product-warning').fadeOut();
      }
    },
    error(err) {
      let responseText = JSON.parse(err.responseText);
      if (err.status == 422) {
        $('.tb-product-warning').fadeIn();
        loading.classList.remove('active');
        $('.tb-product-warning p').html(responseText.description)
        let successCon = "<div class='tb-toast'>" + responseText.description + "</div>"
        $('body').append(successCon);
        setTimeout(function () {
          $('.tb-toast').remove();
        }, 1000)
      }
    }
  })
  console.log(123);
  cartGtag();
})



// 打开购物车
// function toggleCart(type) {
//   loading.classList.remove('active');
//   let cartModal = document.querySelector('.tb-shop-cart');
//   let shade = document.querySelector('.tb-shade');
//   if (type == 'open') {
//     cartModal.classList.add('show')
//     shade.classList.add('show')
//   } else if (type == 'add') {
//     cartModal.classList.add('show')
//     setTimeout(() => {
//       cartModal.classList.remove('show')
//       shade.classList.remove('show')
//     }, 5000)
//   } else {
//     cartModal.classList.remove('show')
//     shade.classList.remove('show')
//   }
// }

$('.tb-product-coupon-sale').click(function () {
  $('.tb-product-coupon-hint').fadeIn();
  setTimeout(() => {
    $('.tb-product-coupon-hint').fadeOut();
  }, 3000);
})

$('.tb-product-coupon-hint i').click(function () {
  $('.tb-product-coupon-hint').fadeOut();
})


let btnName;
if(pathname.includes('/fr')){
  btnName = 'ACHETER MAINTENAN'
}else if(pathname.includes('/de')){
  btnName = 'JETZT KAUFEN'
}else{
  btnName = 'BUY IT NOW'
}
// var scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
//   if (window.ShopifyBuy) {
//     if (window.ShopifyBuy.UI) {
//       ShopifyBuyInit();
//     } else {
//       loadScript();
//     }
//   } else {
//     loadScript();
//   }

//   function loadScript() {
//     console.log(1)
//     var script = document.createElement('script');
//     script.async = true;
//     script.src = scriptURL;
//     (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
//     script.onload = ShopifyBuyInit;
//   }

//   function ShopifyBuyInit() {
//     console.log(2)
//     var client = ShopifyBuy.buildClient({
//       domain: 'eu.havalab.com',
//       storefrontAccessToken: 'ded23ddfb8835aa67e083f168367bb4e',
//     });
//     let productBtn = document.getElementById('product-component');
//     let productId = productBtn.getAttribute('data-id');
//     ShopifyBuy.UI.onReady(client).then(function (ui) {
//       ui.createComponent('product', {
//         id: productId,
//         node: document.getElementById('product-component'),
//         moneyFormat: '%24%7B%7Bamount%7D%7D',
//         options: {
//           "product": {
//             iframe: false,
//             "buttonDestination": "checkout",
//             "contents": {
//               "img": false,
//               "title": false,
//               "price": false
//             },
//             "classes": {
//               button: "tb-fixed-checkout"
//             },
//             "text": {
//               "button": btnName
//             }
//           }
//         }
//       });
//     });
//   }

// checkout按钮
$('#product-checkout-button').click(function () {
  const variantId = $('#variantId').val() || currentProduct.getAttribute('data-id');
  const quantity = $('#productQty').val() || 1;
  
  const mutation = `
    mutation {
      cartCreate(
        input: {
          lines: [
            {
              quantity: ${quantity}
              merchandiseId: "gid://shopify/ProductVariant/${variantId}"
            }
          ]
        }
      ) {
        cart {
          id
          checkoutUrl
        }
      }
    }
  `;

  fetch('/api/2025-01/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': 'ded23ddfb8835aa67e083f168367bb4e'
    },
    body: JSON.stringify({ query: mutation })
  })
  .then(response => response.json())
  .then(result => {
    if (result.data && result.data.cartCreate && result.data.cartCreate.cart) {
      window.location.href = result.data.cartCreate.cart.checkoutUrl;
    }
  })
  .catch(error => {
    console.error('Error:', error);
  });
});

if(!pathname.includes('/fr')&&!pathname.includes('/de')){
  //$(".price-off").css("display","none");
}
console.log(pathname);

// 倒计时
let year = $('#countdown').data('year') || 2022;
let month = $('#countdown').data('month') || 1
let day = $('#countdown').data('day')
let hour = $('#countdown').data('hour')
let minute = $('#countdown').data('minute')
let second = $('#countdown').data('second')
if ($('#countdown').length) {
  $('#countdown').countDown({
    omitWeeks: true,
    targetDate: {
      'day': parseInt(day),
      'month': parseInt(month),
      'year': parseInt(year),
      'hour': parseInt(hour),
      'min': parseInt(minute),
      'sec': parseInt(second)
    }
  });
}

var productDetailBannerSwiper = new Swiper(".productDetailBanner", {
  pagination: {
    el: ".productDetailBanner .swiper-pagination",
  },
  navigation: {
    nextEl: ".productDetailBanner .swiper-button-next",
    prevEl: ".productDetailBanner .swiper-button-prev",
  },
});


var opinionThumbsSwiper = new Swiper(".opinionThumbsSwiper", {
  spaceBetween: 10,
  slidesPerView: 4,
  freeMode: true,
  watchSlidesProgress: true,
});
var opinionSwiper = new Swiper(".opinionSwiper", {
  spaceBetween: 10,
  navigation: {
    nextEl: ".opinionSwiper .swiper-button-next",
    prevEl: ".opinionSwiper .swiper-button-prev",
  },
  thumbs: {
    swiper: opinionThumbsSwiper,
  },
});

$('.option-title-box').click(function () {
  $(this).toggleClass('active');
  $(this).next().toggleClass('tw-hidden');
});


var madeSwiper = new Swiper(".madeSwiper", {
  spaceBetween: 12,
  slidesPerView: 1.4,
  scrollbar: {
    el: ".madeSwiper .swiper-scrollbar",
  },
});


// 订阅提交
$("#pre-sell-subscribe").click(function () {
  var tag = $(this).data('tag') || '';
  // 此处为请求
  $.ajax({
    url: 'https://backend.turboant.com/index/api/dealshopifycustomerHavaWashPre',
    type: 'post',
    data: {
      account:'e88e1d-3.myshopify.com',
      email: $('#pre-sell-email').val(),
      tag: tag
    },
    dataType: 'json',
    success: (res) => {
        const { status, msg } = res;
        if(status === 1){
          $('#pre-sell-subscribe-success').show();
        }else{
          $('#pre-sell-subscribe').append(`<div class='tb-toast'>${msg}</div>`);
          setTimeout(function () {
            $('.tb-toast').remove();
          }, 1000)
        }
    }
  });
  
  //请求成功后操作(换成接口后此处可以删除)
  // $('.subscriber-form').hide();
  // $('.subscriber-result').show();
});

$('.product-add-cart-botton').on('click', function (e) {
  let id = $(this).data('variantid') || $(this).data('id');
  addCartFn(id)
})

// 产品加购
function addCartFn(id){
  let formDate = {
    form_type: 'product',
    utf8: '✓',
    quantity:1,
    id,
  }
  $.ajax({
    url: '/cart/add.js',
    type: 'POST',
    data: formDate,
    dataType: 'json',
    success(res) {
      if (res) {
        getCartData();
      }
    },
    error(err) {
      let responseText = JSON.parse(err.responseText);
      if (err.status == 422) {
        let successCon = "<div class='tb-toast'>" + responseText.description + "</div>"
        $('body').append(successCon);
        setTimeout(function () {
          $('.tb-toast').remove();
        }, 1000)
      }
    }
  });
}

function initR09Swiper() {
  var R09S5Swiper = new Swiper(".tb-product-tab-main .R09S5Swiper", {
    slidesPerView: 3.3,
    spaceBetween: 24,
    scrollbar: {
      el: ".tb-product-tab-main  .R09S5Swiper .swiper-scrollbar",
    },
    navigation: {
      nextEl: ".tb-product-tab-main  .R09S5SwiperContainer .swiper-button-next",
      prevEl: ".tb-product-tab-main  .R09S5SwiperContainer .swiper-button-prev",
    },
  });

  var R09S5SwiperMobileThumbs = new Swiper(".tb-product-tab-main  .R09S5SwiperMobileThumbs", {
    spaceBetween: 12,
    slidesPerView: 2,
    watchSlidesProgress: true
  });

  var R09S5SwiperMobileDescribe = new Swiper(".tb-product-tab-main  .R09S5SwiperMobileDescribe", {
    slidesPerView: 1,
    spaceBetween: 10,
    watchSlidesProgress: true,
    scrollbar: {
      el: ".tb-product-tab-main  .R09S5SwiperMobileDescribe .swiper-scrollbar",
    },
    thumbs: {
      swiper: R09S5SwiperMobileThumbs,
    }
  });

  var R09S5SwiperMobile = new Swiper(".tb-product-tab-main  .R09S5SwiperMobile", {
    slidesPerView: 1,
    spaceBetween: 10,
    thumbs: {
      swiper: R09S5SwiperMobileThumbs,
    }
  });


  // 使用事件委托来同步滑动
  R09S5SwiperMobileThumbs.on('slideChange', function() {
    let index = this.activeIndex;
    if(R09S5SwiperMobileDescribe.activeIndex !== index) {
      R09S5SwiperMobileDescribe.slideTo(index);
    }
    if(R09S5SwiperMobile.activeIndex !== index) {
      R09S5SwiperMobile.slideTo(index);
    }
  });

  R09S5SwiperMobileDescribe.on('slideChange', function() {
    let index = this.activeIndex;
    if(R09S5SwiperMobile.activeIndex !== index) {
      R09S5SwiperMobile.slideTo(index);
    }
  });
  R09S5SwiperMobile.on('slideChange', function() {
    let index = this.activeIndex;
    if(R09S5SwiperMobileDescribe.activeIndex !== index) {
      R09S5SwiperMobileDescribe.slideTo(index);
    }
  });
}
initR09Swiper();

var T02M4ThumbsSwiper = new Swiper(".T02M4ThumbsSwiper", {
  spaceBetween: 90,
  slidesPerView: 5,
  watchSlidesProgress: true,
});

var T02M4Swiper = new Swiper(".T02M4Swiper", {
  slidesPerView: 1,
  spaceBetween: 10,
  thumbs: {
    swiper: T02M4ThumbsSwiper,
  }
});

var T02M4SwiperDescription = new Swiper(".T02M4SwiperDescription", {
  slidesPerView: 1,
  spaceBetween: 10,
  watchSlidesProgress: true,
  thumbs: {
    swiper: T02M4ThumbsSwiper,
  }
});

T02M4ThumbsSwiper.on('slideChange', function() {
  let index = this.activeIndex;
  if(T02M4SwiperDescription.activeIndex !== index) {
    T02M4SwiperDescription.slideTo(index);
  }
});

T02M4SwiperDescription.on('slideChange', function() {
  let index = this.activeIndex;
  if(T02M4Swiper.activeIndex !== index) {
    T02M4Swiper.slideTo(index);
  }
});
T02M4Swiper.on('slideChange', function() {
  let index = this.activeIndex;
  if(T02M4SwiperDescription.activeIndex !== index) {
    T02M4SwiperDescription.slideTo(index);
  }
});

var T02M4SwiperMobile = new Swiper(".T02M4SwiperMobile", {
  slidesPerView: 1.3,
  spaceBetween: 0,
  loop: true,
  centeredSlides: true, 
  pagination: {
    el: ".T02M4SwiperMobile .swiper-pagination",
  },
});

$('.module3-item').on('click', function () {
  $(this).find('.module3-arrow').toggleClass('tw-rotate-90');
  $(this).find('.module3-description').toggleClass('tw-hidden');
})

var u01m4Swiper = new Swiper(".u01m4Swiper", {
  slidesPerView: 1.2,
  spaceBetween: 12,
  scrollbar: {
    el: ".u01m4Swiper .swiper-scrollbar",
  },
});



var module6ImageSwiper = new Swiper(".module6ImageSwiper", {
  slidesPerView: 1,
  loop: true,
  pagination: {
    el: ".module6ImageSwiper .swiper-pagination",
    clickable: true,
  },
  on: {
    slideChange: function() {
      // 移除所有导航项的active类
      $('.module6ImageSwiperNav > div').removeClass('swiper-slide-thumb-active');
      // 给当前slide对应的导航项添加active类（使用realIndex来处理loop模式）
      $('.module6ImageSwiperNav > div').eq(this.realIndex).addClass('swiper-slide-thumb-active');
    },
    init: function() {
      // 初始化时设置第一个导航项为active
      $('.module6ImageSwiperNav > div').eq(0).addClass('swiper-slide-thumb-active');
    }
  }
});

// 添加导航项点击事件
$('.module6ImageSwiperNav > div').on('click', function() {
  var index = $(this).index();
  module6ImageSwiper.slideToLoop(index);
});

var module7Swiper = new Swiper(".module7Swiper", {
  slidesPerView: isMobile() ? 1 : 4,
  spaceBetween: 0,
  pagination: {
    el: ".module7Swiper .swiper-pagination",
  },
  on: {
    slideChange: function() {
      // 移除所有导航项的active类
      $('.module7SwiperNavItem').removeClass('!tw-text-black !tw-border-black');
      // 给当前slide对应的导航项添加active类
      $('.module7SwiperNavItem').eq(this.activeIndex).addClass('!tw-text-black !tw-border-black');
    },
    init: function() {
      // 初始化时设置第一个导航项为active
      $('.module7SwiperNavItem').eq(0).addClass('!tw-text-black !tw-border-black');
    }
  }
});

// 添加导航项点击事件
$('.module7SwiperNav > .module7SwiperNavItem').on('click', function() {
  var index = $(this).index();
  module7Swiper.slideTo(index);
});